// Game metadata (the playable logic lives in components/games/*).
export const GAMES = [
  {
    id: "alphabet-match",
    icon: "Type",
    color: "#FF91B8",
    title: { en: "Alphabet Match", zh: "字母配对" },
    desc: { en: "Match each uppercase letter with its lowercase partner.", zh: "把每个大写字母和它的小写伙伴配对。" },
    hasDifficulty: true,
  },
  {
    id: "number-challenge",
    icon: "Calculator",
    color: "#147DEB",
    title: { en: "Number Challenge", zh: "数字挑战" },
    desc: { en: "Solve quick addition and subtraction problems against the clock.", zh: "在限时内快速解答加减法题目。" },
    hasDifficulty: true,
  },
  {
    id: "shape-color-quiz",
    icon: "Shapes",
    color: "#45C878",
    title: { en: "Shape & Color Quiz", zh: "形状与颜色测验" },
    desc: { en: "Name the shape and its color as fast as you can.", zh: "尽快说出形状和它的颜色。" },
    hasDifficulty: false,
  },
  {
    id: "word-builder",
    icon: "SpellCheck",
    color: "#FFC928",
    title: { en: "Word Builder", zh: "单词拼拼乐" },
    desc: { en: "Unscramble the letters to build the correct word.", zh: "把打乱的字母重新排成正确的单词。" },
    hasDifficulty: true,
  },
  {
    id: "knowledge-quiz",
    icon: "Brain",
    color: "#147DEB",
    title: { en: "General Knowledge Quiz", zh: "常识问答" },
    desc: { en: "Fun questions about animals, space, and the world.", zh: "关于动物、太空和世界的趣味问题。" },
    hasDifficulty: false,
  },
  {
    id: "memory-match",
    icon: "Grid3x3",
    color: "#FF91B8",
    title: { en: "Memory Matching", zh: "记忆翻翻乐" },
    desc: { en: "Flip the cards and find all the matching pairs.", zh: "翻开卡片，找出所有配对。" },
    hasDifficulty: true,
  },
];

export function getGame(id) {
  return GAMES.find((g) => g.id === id);
}
